<template>
  <div class="IDcard">
    <div class="cardLunbo" v-show="hasCard">
      <div class="showPage">{{ current + 1 }}/{{ cardNum }}</div>
      <van-swipe @change="onChange" :show-indicators="false">
        <van-swipe-item v-for="item in xingshiList" :key="item.id">
          <div class="cardPic">
            <div class="zhenjian">
              <div class="leftIcon">
                <img src="../assets/images/xingshiIcon.png" alt="" />
              </div>
              <div class="word">
                <div class="zhenjianName">机动车行驶证</div>
                <div class="pingzhen">电子凭证</div>
              </div>
            </div>
            <div class="dibu" v-show="hasCard">
              <div class="left" @click="goView(item.file_data)">
                <!-- <img src="../assets/images/dianziIcon.png" alt="" /> -->
                <div class="word">查看电子证照</div>
              </div>
              <div class="right" @click="handleKookCodeClick">
                <div class="word">查看二维码</div>
                <img
                  style="
                    height: 14px;
                    width: 14px;
                    margin-left: 5px;
                    vertical-align: middle;
                  "
                  src="../assets/images/code-icon.png"
                  alt=""
                />
              </div>
            </div></div
        ></van-swipe-item>
      </van-swipe>
    </div>
    <div class="cardPic" v-show="!hasCard">
      <div class="zhenjian">
        <div class="leftIcon">
          <img src="../assets/images/xingshiIcon.png" alt="" />
        </div>
        <div class="word">
          <div class="zhenjianName">机动车行驶证</div>
          <div class="pingzhen">电子凭证</div>
        </div>
      </div>
    </div>
    <div class="shuoming">
      <div class="title">证件说明</div>
      <div class="miaosu">
        <div class="miaosuTitle">证件描述:</div>
        <div class="miaosuWord">
          本证件系与苏州市公安局交通警察支队核发的机动车行驶证相对应的电子标签，仅限于在苏州市行政区域范围内使用。
        </div>
      </div>
      <div class="fanwei">
        <div class="fanweiTitle">适用范围:</div>
        <div class="fanweiWord">
          1、交警路面证件查验；<br />
          2、交通违法现场简易程序处理；<br />
          3、轻微交通事故快速处理。<br />
          *以下情况电子行驶证不适用，应提供实体行驶证：<br />
          1、办理行政、刑事案件调查需要的；<br />
          2、窗口办理车驾管业务的；<br />
          3、其他需要提供实体行驶证的清况。<br />
        </div>
      </div>
      <div class="changjin">
        特别说明：驾驶机动车上道路行驶时，仍应当按法律规定随车携带实体机动车行驶证。交警要求出示的，应当出示。
      </div>
    </div>
    <van-popup v-model="codeShow" class="my-popup">
      <vue-qr
        :size="191"
        :margin="0"
        :auto-color="true"
        :dot-scale="1"
        :text="appSrc"
      />
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from "vant";
import Vue from "vue";
import VueQr from "vue-qr";
import { Swipe, SwipeItem } from "vant";
import { doRem } from "../utils/setrem";
import qs from "qs";
import { Toast } from "vant";

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  mounted() {
    this.chakan();
    // this.getToken()
  },
  data() {
    return {
      hasCard: false,

      xingshiList: [],
      cardNum: "",
      current: 0,
      appSrc: "",
      codeShow: false,
    };
  },
  components: { VueQr },

  methods: {
    handleKookCodeClick() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({ cardType: 10 });
      this.$axios
        .post("/identity/user/otherCert/getQRcode", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            this.codeShow = true;
            this.appSrc = res.data.data;
          }
        })
        .catch((err) => {
          Toast.clear();
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    onChange(index) {
      this.current = index;
    },
    goView(src) {
      this.$router.push({
        name: "ZhenjianView",
        params: {
          src,
        },
      });
    },
    chakan() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });

      let params = qs.stringify({
        cardType: 10,
      });
      this.$axios
        .post("identity/user/elecCertificate/getCertificateInfo", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            this.hasCard = true;
            res.data.data.forEach((item) => {
              this.xingshiList.push(item);
            });
            this.cardNum = this.xingshiList.length;
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    getToken() {
      let token = this.$route.query.token;
      localStorage.setItem("token", token);
    },
  },
};
</script>

<style lang="scss" scoped>
.IDcard {
  background-color: #eef4f6;
  padding: 1.5rem 2rem 6.25rem 2rem;
  height: auto;
}
.cardLunbo {
  position: relative;
  .showPage {
    position: absolute;
    width: 5.625rem;
    height: 2.75rem;
    background: rgba(0, 0, 0, 0.85);
    color: #ffffff;
    top: 1.875rem;
    right: 1.625rem;
    z-index: 100;
    text-align: center;
    line-height: 2.75rem;
    border-radius: 1.375rem;
  }
}
.cardPic {
  position: relative;
  background-image: url("../assets/images/xingshi.png");
  height: 25rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 4.25rem;
  padding-left: 3.375rem;
  .zhenjian {
    display: flex;
    align-items: center;

    img {
      width: 5.5rem;
    }
    .word {
      margin-left: 1.625rem;
      line-height: 3rem;
      .zhenjianName {
        color: #ffffff;
        font-size: 2rem;
      }
      .pingzhen {
        color: rgba(255, 255, 255, 0.8);
        font-size: 1.625rem;
      }
    }
  }
  .dibu {
    width: 100%;
    background-image: url("../assets/images/dianziBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5.5rem;
    .left {
      position: relative;
    }
    .left::after {
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -7px;
      content: "";
      height: 14px;
      width: 1px;
      background-color: #fff;
    }
    .left,
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
    }
    div {
      .word {
        margin-left: 1.25rem;
        font-size: 1.875rem;
        color: #ffffff;
      }
      img {
        width: 3.25rem;
        height: 2.375rem;
      }
    }
  }
}
.my-popup {
  padding: 10px;
}
.shuoming {
  margin-top: 1.25rem;
  background-color: #fff;
  padding: 2.5rem 2rem 1.5rem 2rem;
  border-radius: 1rem;
  .title {
    font-size: 2.125rem;
    color: #19212a;
  }
  .miaosu {
    margin-top: 2.125rem;
    color: #555555;
    font-size: 1.6875rem;
    .miaosuWord {
      margin-top: 1.25rem;
    }
  }
  .fanwei {
    color: #555555;
    font-size: 1.6875rem;
    margin-top: 3.75rem;
    .fanweiWord {
      margin-top: 1.25rem;
      line-height: 3.25rem;
    }
  }
  .changjin {
    color: #555555;
    font-size: 1.6875rem;
    margin-top: 1.25rem;
  }
}
</style>